/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * An API Key just after creation.
 */
export interface ApiKeyFull {
    /** Timestamp string according to [RFC 3339](https://www.rfc-editor.org/rfc/rfc3339). */
    expiration: Date;
    /** Secret part of the API key. */
    secret: string;
    /** SubjectID of API key. */
    subjectId: string;
}
